export default "__VITE_ASSET__e479b083__"